module.exports = __webpack_public_path__ + "img/EnGarde.1a56d03d.svg";